import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../fichierCss/Recherche.css'

const Recherche = () => {
    const [terme, setTerme] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (terme.trim()) {
            navigate(`/recherche?terme=${encodeURIComponent(terme.trim())}`);
        }
    };

    return (
        <form className="recherche-bar" onSubmit={handleSubmit}>
            <span className="recherche-icone" aria-hidden="true">🔍</span>
            <input
                className="recherche-input"
                type="text"
                placeholder="Rechercher un contenu..."
                aria-label="Rechercher"
                id="recherche"
                value={terme}
                onChange={(e) => setTerme(e.target.value)}
            />
            <button className="recherche-btn" type="submit">
                <span className="recherche-btn-desktop">Rechercher</span>
                <span className="recherche-btn-mobile" aria-label="Rechercher">OK</span>
            </button>
        </form>
    );
}
export default Recherche;
